import ActionTypes from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  otpToken: null,
  errorMessage: null,
  user: null,
  authority_class: null,
  otpAttemptCount: 0,
  errorCode: null,
  accessToken: null,
  refreshToken: null,
  screen_message: "",
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    //ACCESS TOKEN 
    case ActionTypes.ACCESS_TOKEN_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      };
    case ActionTypes.ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        otpToken: action.payload.otpToken,
        errorMessage: null,
      };
    case ActionTypes.ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        isFetching: false,
        otpToken: null,
        errorMessage: action.payload.message,
      };
    //VERIFY OTP
    case ActionTypes.VERIFY_OTP_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case ActionTypes.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        otpAttemptCount: 0,
        user: action.payload.user || state.user,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      };

    case ActionTypes.VERIFY_OTP_FAILURE: {
      const payload = action.payload || {};
      const errorType = payload.error_code;

      const isWrongOtp = errorType === "OTP_FORMAT_ERR_MSG";
      const isOtp3Times = errorType === "OTP_VERIFY_FAILED_3TIMES_MSG";
      const isLockedUser = errorType === "LOCKED_USER_MSG";

      let nextCount = state.otpAttemptCount;

      if (isWrongOtp) {
        nextCount = state.otpAttemptCount + 1;
      } else if (isOtp3Times) {
        nextCount = 3;
      } else if (isLockedUser) {
        nextCount = 4;
      }

      return {
        ...state,
        isFetching: false,
        errorMessage: payload.message || payload,
        otpAttemptCount: nextCount,
      };
    }
    //RESEND OTP
    case ActionTypes.RESEND_OTP_REQUEST:
      return { 
        ...state, 
        isFetching: false, 
        otpToken: action.payload,
        errorMessage: null
      };
    case ActionTypes.RESEND_OTP_SUCCESS:
      return {
        ...state,
        otpToken: action.payload
      };
    case ActionTypes.RESEND_OTP_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload
      };
    //FETCH USER
    case ActionTypes.FETCH_USER_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      };
    case ActionTypes.FETCH_USER_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          isFetching: false,
          authority_class: action.payload.authority_class,
          ...action.payload 
        },
        errorMessage: null
      };
    case ActionTypes.FETCH_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.message,
      };
    // LOGOUT
    case ActionTypes.LOGOUT_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case ActionTypes.LOGOUT_SUCCESS:
      return {
        ...initialState,
        isFetching: false
      };

    case ActionTypes.LOGOUT_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload
      };
    // REFRESH TOKEN
    case ActionTypes.REFRESH_ACCESS_TOKEN_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case ActionTypes.REFRESH_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken || state.refreshToken,
        errorMessage: null,
      };
    case ActionTypes.REFRESH_ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.message
      };

    default:
      return state;
  }
};

export default loginReducer;
